import SearchIcon from '@mui/icons-material/Search'
import { InputAdornment, OutlinedInput, Stack, Typography } from '@mui/material'
import Fuse from 'fuse.js'
import React, { useEffect, useState } from 'react'
import TeamList from '../Components/TeamViewComponents/TeamList'
import CustomButton from '../Components/UiComponents/CustomButton'
import InputField from '../Components/UiComponents/InputField'
import Loader from '../Components/UiComponents/Loader'
import { useCreateMemberMutation, useDeleteMemberMutation, useVerifyUserMutation } from '../Services/userApi'
import { color } from '../Styles/Color'

const TeamView = () => {

  const [verifyUser, { data: sgUser, isLoading: isUserVerifing }] = useVerifyUserMutation();

  const [searchedKey, setSearchedKey] = useState("")

  const [searchedData, setSearchedData] = useState(sgUser?.user_metadata?.member_users)

  useEffect(() => {
    const options = {
      includeScore: true,
    }

    const fuse = new Fuse(sgUser?.user_metadata?.member_users, options)

    if (searchedKey.length > 0) {
      setSearchedData(fuse.search(searchedKey).filter(key => key.score < 0.2).map(key => key.item))
    } else {
      setSearchedData(sgUser?.user_metadata?.member_users)
    }

  }, [sgUser?.user_metadata?.member_users, searchedKey])

  const [email, setEmail] = useState("")

  const [handleSubmit, { isLoading, isSuccess: isMemberCreated }] = useCreateMemberMutation();

  useEffect(() => {
    if (isMemberCreated) {
      setEmail("")
      verifyUser()
    }
  }, [isMemberCreated, verifyUser])

  const handleAdd = () => {
    handleSubmit({
      email,
      productType: "SCALEGEN"
    })
  }


  const [deleteMember, { isLoading: isDeleting, isSuccess }] = useDeleteMemberMutation()

  useEffect(() => {
    verifyUser()
  }, [verifyUser])

  useEffect(() => {
    if (isSuccess) {
      verifyUser()
    }
  }, [isSuccess, verifyUser])

  const onDelete = (email) => {
    deleteMember({ "email": email, "productType": "SCALEGEN" })
  }

  if (isDeleting || isUserVerifing || isLoading) {
    return <Stack height="80vh">
      <Loader />
    </Stack>
  }

  return (
    <Stack
      spacing={5}
      overflow="auto"
      // sx={{
      //   '&::-webkit-scrollbar': {
      //     display: 'none',
      //   }
      // }}
      p={1}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center" >
        <Typography variant='h1'>
          Members
        </Typography>
        <OutlinedInput
          value={searchedKey}
          size='small'
          border={`1px solid ${color.borders}`}
          onChange={e => setSearchedKey(e.target.value)}
          sx={{
            borderRadius: "8px",
            boxShadow: "0px 0px 4px 0px #00000029",
            width: "60%",
          }}
          placeholder='Search team member'
          startAdornment={<InputAdornment position="start">
            <SearchIcon fontSize='small' />
          </InputAdornment>}
        />
      </Stack>
      <Stack spacing={1}>
        <Typography variant='h2'>Add a New Member</Typography>
        <Stack direction="row" gap={1}>
          <Typography variant='body2' color={color.secondaryText}>
            Invite others to join your workspace.
          </Typography>
          <Typography variant='body2' color={color.primary}>
            Learn More
          </Typography>
        </Stack>
      </Stack>
      <Stack spacing={1}>
        <Stack direction="row" alignItems="center" fontSize="15px" gap={4}>
          <Stack width="60%">
            <Typography variant='h2'>
              Email address
            </Typography>
          </Stack>
        </Stack>
        <Stack direction="row" alignItems="center" fontSize="15px" gap={4}>
          <InputField
            width="60%"
            placeholder="e.g. name@company.com"
            state={email}
            setState={(e) => setEmail(e.target.value)}
          />
          <CustomButton width="10%"
            disabled={email.length === 0}
            onClick={handleAdd}
          >
            <Stack alignItems="center" direction="row" gap={0.5} >
              Add
            </Stack>
          </CustomButton>
        </Stack>
      </Stack>
      <Stack maxHeight="55vh">
        <TeamList data={searchedData || []} handleDelete={onDelete} />
      </Stack>
    </Stack>
  )
}

export default TeamView